import React, {useEffect}  from "react";
import { useUpdateAboutAndSustainabilityContentMutation } from "../../../../store/services/AboutAndSustainabilityContentService";
import { useUpdatePartnershipContentMutation } from "../../../../store/services/PartnershipContentService"
import { Button, Col, Row } from "react-bootstrap";
import toast from "react-hot-toast";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import Dropzone from "../../../../components/Dropzone/Dropzone";
import { MdAdd, MdDelete } from "react-icons/md";
//import CKEditorField from "../../ckEditor/CKEditorField";
//import CKEditorField from "../../../../components/ckEditor/CKEditorField";
import CKEditorNew from "../../../../components/newCkEditor/ckEditor";


function PartnershipContentForm({ data }) {
//   const [updateAboutAndSustainability, { isLoading: isUpdating }] =
//     useUpdateAboutAndSustainabilityContentMutation();
const [updatePartnershipContent, { isLoading: isUpdating }] =
        useUpdatePartnershipContentMutation();
  const { createdAt, updatedAt, ...PageInfo } = data;

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
  } = useForm({
    mode: "onTouched",
    defaultValues: { ...PageInfo },
  });

  
  const onSubmit = async (data) => {
    try {
      const res = await updatePartnershipContent({
        updatedData: data,
      });
      if (res?.data?.status === "success") {

        return toast.success(res?.data?.message);
      }
    } catch (error) {
      console.error("Failed to delete the meal:", error); // Handle error
    }
  };

  useEffect(() => {
    let toastId;

    if (isUpdating) {
      // Show loading toast and save the ID
      toastId = toast.loading("Updating...");
    } else if (toastId) {
      // Dismiss the loading toast when isUpdating is false
      toast.dismiss(toastId);
    }

    return () => {
      // Cleanup: Ensure toast is dismissed if the component unmounts
      if (toastId) {
        toast.dismiss(toastId);
      }
    };
  }, [isUpdating]);

  return (
    <Col lg="12" md="12" sm="12" className="my-2">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div
          className="formWrpper px-lg-5 p-md-4 p-3 rounded"
          style={{ background: "#EEEEEE" }}
        >
          <Row className="justify-content-between">
            <Col lg="12">
              {/* <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                About us page content
              </h4> */}
            </Col>
           
           
            <Col lg="6" md="6" sm="12" className="mb-3">
              <div className="py-2">
                <label className="form-label fw-sbold text-muted ps-2 m-0">
                  Image
                </label>
                <Controller
                  name="image"
                  control={control}
                  rules={{ required: "Image is required" }}
                  render={({ field }) => (
                    <Dropzone
                      field="image"
                      setFieldValue={setValue}
                      value={field.value}
                      error={errors}
                    />
                  )}
                />
                {errors.image && (
                  <span className="text-danger">{errors.image.message}</span>
                )}
              </div>
            </Col>
            <Col lg="6" md="6" sm="12" className="my-2">
              {/* Name Field */}
              <div className="py-2">
                <label className="form-label fw-sbold text-muted ps-2 m-0">
                 Heading
                </label>
                <input
                  type="text"
                  name="heading"
                  {...register("heading", {
                    required: "Please enter heading",
                  })}
                  className="form-control"
                />

                {errors.heading && (
                  <span className="text-danger">
                    {errors.heading.message}
                  </span>
                )}
              </div>
            </Col>

            <Col lg="6" md="6" sm="12" className="my-2">
              {/* Name Field */}
              <div className="py-2">
                <label className="form-label fw-sbold text-muted ps-2 m-0">
                 Description
                </label>
                <input
                  type="text"
                  name="desc"
                  {...register("desc", {
                    required: "Please enter description",
                  })}
                  className="form-control"
                />

                {errors.desc && (
                  <span className="text-danger">
                    {errors.desc.message}
                  </span>
                )}
              </div>
            </Col>




            {/* businessPartnership */}

            <Col lg="12">
              <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                Partnership
              </h4>
            </Col>


            <Col lg="6" className="my-2">
              <Controller
                name="businessPartnership.icon"
                control={control}
                rules={{ required: "Image is required" }}
                render={({ field }) => (
                  <Dropzone
                    {...field}
                    field={`businessPartnership.icon`}
                    setFieldValue={setValue}
                    value={field.value}
                    error={errors?.businessPartnership?.icon}
                  />
                )}
              />
              {errors.businessPartnership?.icon && (
                <span className="text-danger">
                  {errors.businessPartnership.icon.message}
                </span>
              )}
            </Col>

            <Col lg="6" className="my-2">
              <div className="py-2">
                <label className="form-label fw-sbold text-muted ps-2 m-0">
                 Heading
                </label>
                <input
                  type="text"
                  {...register("businessPartnership.heading", {
                    required: "Please enter heading",
                  })}
                  className={`form-control ${errors.businessPartnership?.heading ? "is-invalid" : ""
                    }`}
                />
                {errors.businessPartnership?.heading && (
                  <span className="text-danger">
                    {errors.businessPartnership.heading.message}
                  </span>
                )}
              </div>
            </Col>

            

            <Col lg="12" md="12" className="my-2">
                  {/* Description Field */}
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Content
                    </label>

                    <Controller
                      name="businessPartnership.content"
                      control={control}
                      rules={{ required: "Please enter content" }}
                      render={({ field }) => (
                        <CKEditorNew
                          field="businessPartnership.content"
                          setFieldValue={setValue}
                          value={field.value}
                          error={errors}
                          placeholder="Type your content here..."
                        />
                      )}
                    />
                    
                    {errors.businessPartnership?.content && (
                      <span className="text-danger">
                        {errors.businessPartnership.content.message}
                      </span>
                    )}
                  </div>
                </Col>




                {/* influencer */}

            <Col lg="12">
              <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
               Affiliates
              </h4>
            </Col>


            <Col lg="6" className="my-2">
              <Controller
                name="influencer.icon"
                control={control}
                rules={{ required: "Image is required" }}
                render={({ field }) => (
                  <Dropzone
                    {...field}
                    field={`influencer.icon`}
                    setFieldValue={setValue}
                    value={field.value}
                    error={errors?.influencer?.icon}
                  />
                )}
              />
              {errors.influencer?.icon && (
                <span className="text-danger">
                  {errors.influencer.icon.message}
                </span>
              )}
            </Col>

            <Col lg="6" className="my-2">
              <div className="py-2">
                <label className="form-label fw-sbold text-muted ps-2 m-0">
                 Heading
                </label>
                <input
                  type="text"
                  {...register("influencer.heading", {
                    required: "Please enter heading",
                  })}
                  className={`form-control ${errors.influencer?.heading ? "is-invalid" : ""
                    }`}
                />
                {errors.influencer?.heading && (
                  <span className="text-danger">
                    {errors.influencer.heading.message}
                  </span>
                )}
              </div>
            </Col>

            

            <Col lg="12" md="12" className="my-2">
                  {/* Description Field */}
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Content
                    </label>

                    <Controller
                      name="influencer.content"
                      control={control}
                      rules={{ required: "Please enter content" }}
                      render={({ field }) => (
                        <CKEditorNew
                          field="influencer.content"
                          setFieldValue={setValue}
                          value={field.value}
                          error={errors}
                          placeholder="Type your content here..."
                        />
                      )}
                    />
                    
                    {errors.influencer?.content && (
                      <span className="text-danger">
                        {errors.influencer.content.message}
                      </span>
                    )}
                  </div>
                </Col>

          

            {/* Submit Button */}
            <Col lg="12" className="text-right my-3">
              <Button
                type="submit"
                className="d-flex align-items-center justify-content-center commonBtn"
                disabled={isUpdating}
              >
                Submit
              </Button>
            </Col>
          </Row>
        </div>
      </form>
    </Col>
  );
}

export default PartnershipContentForm;
